import { BaseModel } from './base';

export enum ChargeAmountType {
  fixed = 0,
  percentage = 1,
}

export const ChargeAmountTypeLabels: Record<ChargeAmountType, string> = {
  [ChargeAmountType.fixed]: 'general.fixed',
  [ChargeAmountType.percentage]: 'general.percentage',
};

export class ChargeModel extends BaseModel {
  idChargeModel!: number;
  name!: string;
  amount!: number;
  amountType!: ChargeAmountType;

  override objectID(): string | null {
    return this.idChargeModel?.toString() ?? null;
  }

  get isAmountTypeFixed(): boolean {
    return this.amountType === ChargeAmountType.fixed;
  }

  get isAmountTypePercentage(): boolean {
    return this.amountType === ChargeAmountType.percentage;
  }
}
